export const defaultColumn = [
  { label: 'Serviço', value: 'category', className:"border-l border-[#ff0000]" },
  { label: 'Nome', value: 'display_name' },
  { label: 'Métrica', value: 'unit_for_quantity' },
  { label: 'Preço à Vista', value: 'value', className: 'w-1/3 px-6' },
  { label: 'Última Atualização por', value: 'updated_at' },
]